import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["type"]
const _hoisted_7 = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_8 = {
  key: 1,
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_10 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_17 = { class: "grid" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium"
}
const _hoisted_27 = { class: "mt-6 bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700" }
const _hoisted_28 = { class: "space-y-2" }
const _hoisted_29 = { class: "flex items-center text-sm" }
const _hoisted_30 = {
  key: 2,
  class: "w-5 h-5 rounded-full border-2 border-gray-300 dark:border-gray-600 mr-2 flex-shrink-0"
}
const _hoisted_31 = { class: "flex items-center text-sm" }
const _hoisted_32 = { class: "flex-shrink-0 mr-3" }
const _hoisted_33 = {
  key: 1,
  class: "w-4 h-4 rounded-full border-2 border-gray-300 dark:border-gray-600"
}
const _hoisted_34 = { class: "flex items-center text-sm" }
const _hoisted_35 = { class: "flex-shrink-0 mr-3" }
const _hoisted_36 = {
  key: 2,
  class: "w-4 h-4 rounded-full border-2 border-gray-300 dark:border-gray-600"
}
const _hoisted_37 = { class: "flex items-center text-sm" }
const _hoisted_38 = { class: "flex-shrink-0 mr-3" }
const _hoisted_39 = {
  key: 2,
  class: "w-4 h-4 rounded-full border-2 border-gray-300 dark:border-gray-600"
}
const _hoisted_40 = {
  key: 0,
  class: "mt-4 pt-3 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_41 = { class: "flex items-center text-sm text-green-600 dark:text-green-400 font-semibold" }
const _hoisted_42 = { class: "mt-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 border border-blue-200 dark:border-blue-800" }
const _hoisted_43 = { class: "text-sm font-semibold text-blue-700 dark:text-blue-300 mb-3 flex items-center" }
const _hoisted_44 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_45 = { class: "font-semibold text-blue-600 dark:text-blue-400 mr-2 flex-shrink-0" }
const _hoisted_46 = { class: "text-blue-700 dark:text-blue-300" }
const _hoisted_47 = {
  key: 1,
  class: "text-sm text-gray-500 dark:text-gray-400 italic"
}

import { ref, computed, watch } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import AuthService, { type MonthAssignment } from '@/services/auth'
import { useToastService } from '@/services/toast'
import {
  UserPlus,
  AlertTriangle,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  Calendar,
  Plus,
  X
} from 'lucide-vue-next'

interface Props {
  isVisible: boolean
}

interface Emits {
  (e: 'close'): void
  (e: 'success'): void
}

interface RegistrationData {
  email: string
  password: string
  password_confirmation: string
  user_type: number
  user_status: number
  first_name: string
  middle_name: string
  last_name: string
  city: string
  state: string
  zip_code: string
  phone_number: string
  month_assignments: MonthAssignment[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterEmployee',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const toast = useToastService()

// Initialize default months - assign all 44 months (total modules) starting from current month
const getDefaultMonthAssignments = (): MonthAssignment[] => {
  const TOTAL_MODULES = 44
  const startMonth = 1 // Always start from January
  const startYear = new Date().getFullYear()
  const assignments: MonthAssignment[] = []
  let remaining = TOTAL_MODULES
  let year = startYear
  let month = startMonth

  while (remaining > 0) {
    const monthsThisYear: number[] = []
    while (month <= 12 && remaining > 0) {
      monthsThisYear.push(month)
      month++
      remaining--
    }
    if (monthsThisYear.length > 0) {
      assignments.push({ assigned_year: year, assigned_months: monthsThisYear })
    }
    year++
    month = 1
  }

  return assignments
}

// Form state
const formData = ref<RegistrationData>({
  email: '',
  password: '',
  password_confirmation: '',
  user_type: 1, // Default to Employee
  user_status: 1, // Default to Active
  first_name: '',
  middle_name: '',
  last_name: '',
  city: '',
  state: '',
  zip_code: '',
  phone_number: '',
  month_assignments: getDefaultMonthAssignments()
})

const errors = ref<Record<string, string>>({})
const isLoading = ref(false)

// Password visibility toggles
const showPassword = ref(false)

// Month assignments state
const currentYear = new Date().getFullYear()
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

// Computed
const isFormValid = computed(() => {
  return (
    formData.value.email.length > 0 &&
    !isEmailEmpty.value &&
    !isEmailInvalid.value &&
    formData.value.password.length > 0 && // Password must be generated
    formData.value.password.length >= 6 && // Password must meet minimum length
    formData.value.first_name.length > 0 &&
    formData.value.last_name.length > 0
  )
})

// Live validation computed properties
const isPasswordValidLength = computed(() => {
  return formData.value.password && formData.value.password.length >= 6
})

// Email validation computed property
const isEmailInvalid = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return (
    formData.value.email &&
    formData.value.email.trim() !== '' &&
    !emailRegex.test(formData.value.email)
  )
})

const isEmailEmpty = computed(() => {
  return !formData.value.email || formData.value.email.trim() === ''
})

// Month assignment indicator computed properties
const hasAssignedMonths = computed(() => {
  return formData.value.month_assignments.some(a => a.assigned_months.length > 0)
})

const assignedMonthsSummary = computed(() => {
  return formData.value.month_assignments
    .filter(a => a.assigned_months.length > 0)
    .map(a => ({
      year: a.assigned_year,
      months: a.assigned_months.map(m => monthNames[m - 1]).join(', ')
    }))
})

// Name validation computed properties
const isFirstNameEmpty = computed(() => {
  return !formData.value.first_name || formData.value.first_name.trim() === ''
})

const isLastNameEmpty = computed(() => {
  return !formData.value.last_name || formData.value.last_name.trim() === ''
})

// Methods
const generatePassword = () => {
  // Randomize length between 10 and 12 (inclusive)
  const length = Math.floor(Math.random() * 3) + 10 // 0..2 -> 10..12
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*'
  let password = ''

  // Ensure at least one lowercase, one uppercase, one number, and one special character
  password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]
  password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]
  password += '0123456789'[Math.floor(Math.random() * 10)]
  password += '!@#$%^&*'[Math.floor(Math.random() * 8)]

  // Fill the rest with random characters
  for (let i = 4; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)]
  }

  // Shuffle the password to randomize the position of required characters
  password = password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('')

  formData.value.password = password
  formData.value.password_confirmation = password // Auto-confirm password
}

// Month assignment methods
const addMonthAssignment = () => {
  // Find the next available year that hasn't been used
  const usedYears = formData.value.month_assignments.map(a => a.assigned_year)
  let nextAvailableYear = currentYear

  for (let i = 0; i < 7; i++) {
    const yearToCheck = currentYear + i
    if (!usedYears.includes(yearToCheck)) {
      nextAvailableYear = yearToCheck
      break
    }
  }

  // Determine default months for the new assignment
  let defaultMonths: number[] = []

  // If this is the first assignment for the current year, auto-select current and next month
  if (nextAvailableYear === currentYear && formData.value.month_assignments.length === 0) {
    const currentMonth = new Date().getMonth() + 1 // 1-based month (1 = January, 12 = December)
    const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1

    defaultMonths = [currentMonth]

    // Only add next month if it's still within the current year
    if (currentMonth !== 12) {
      defaultMonths.push(nextMonth)
    }
  }

  formData.value.month_assignments.push({
    assigned_year: nextAvailableYear,
    assigned_months: defaultMonths
  })
}

const removeMonthAssignment = (index: number) => {
  formData.value.month_assignments.splice(index, 1)
}

const toggleMonth = (assignmentIndex: number, month: number) => {
  const assignment = formData.value.month_assignments[assignmentIndex]
  const monthIndex = assignment.assigned_months.indexOf(month)

  if (monthIndex > -1) {
    assignment.assigned_months.splice(monthIndex, 1)
  } else {
    assignment.assigned_months.push(month)
  }

  // Sort months
  assignment.assigned_months.sort((a, b) => a - b)
}

const isMonthSelected = (assignmentIndex: number, month: number): boolean => {
  return formData.value.month_assignments[assignmentIndex]?.assigned_months.includes(month) || false
}

const getAvailableYears = (currentIndex: number): number[] => {
  const usedYears = formData.value.month_assignments
    .map((assignment, index) => (index !== currentIndex ? assignment.assigned_year : null))
    .filter((year): year is number => year !== null)

  const availableYears: number[] = []
  for (let i = 0; i < 10; i++) {
    const year = currentYear + i
    if (!usedYears.includes(year)) {
      availableYears.push(year)
    }
  }

  return availableYears
}

const resetForm = () => {
  formData.value = {
    email: '',
    password: '',
    password_confirmation: '',
    user_type: 1,
    user_status: 1,
    first_name: '',
    middle_name: '',
    last_name: '',
    city: '',
    state: '',
    zip_code: '',
    phone_number: '',
    month_assignments: getDefaultMonthAssignments()
  }
  errors.value = {}
  showPassword.value = false
}

const closeModal = () => {
  if (!isLoading.value) {
    resetForm()
    emit('close')
  }
}

const validateForm = (): boolean => {
  errors.value = {}

  // Required fields validation
  if (!formData.value.email) {
    errors.value.email = 'Email is required'
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.value.email)) {
    errors.value.email = 'Please enter a valid email address'
  }

  if (!formData.value.password) {
    errors.value.password = 'Password is required'
  } else if (formData.value.password.length < 6) {
    errors.value.password = 'Password must be at least 6 characters long'
  }

  if (!formData.value.first_name) {
    errors.value.first_name = 'First name is required'
  }

  if (!formData.value.last_name) {
    errors.value.last_name = 'Last name is required'
  }

  // Auto-set password confirmation to match password
  formData.value.password_confirmation = formData.value.password

  return Object.keys(errors.value).length === 0
}

const handleSubmit = async () => {
  if (!validateForm()) {
    return
  }

  isLoading.value = true
  errors.value = {}

  try {
    const payload = {
      email: formData.value.email,
      password: formData.value.password,
      password_confirmation: formData.value.password_confirmation,
      user_type: formData.value.user_type,
      user_status: formData.value.user_status,
      first_name: formData.value.first_name,
      middle_name: formData.value.middle_name || undefined,
      last_name: formData.value.last_name,
      city: formData.value.city || undefined,
      state: formData.value.state || undefined,
      zip_code: formData.value.zip_code || undefined,
      phone_number: formData.value.phone_number || undefined,
      month_assignments:
        formData.value.month_assignments.filter(
          assignment => assignment.assigned_months.length > 0
        ) || undefined
    }

    const response = await AuthService.registerEmployee(payload)

    if (response.success) {
      isLoading.value = false
      closeModal()

      // Show different success messages based on whether it's a reactivation or new registration
      if (response.data.is_reactivation) {
        toast.success('Employee account reactivated successfully with updated details')
      } else {
        toast.success('Employee registered successfully')
      }

      emit('success')
    } else {
      toast.error('Failed to register employee', response.message)
    }
  } catch (err: any) {
    console.error('Employee registration failed:', err)

    // Handle validation errors
    if (err?.errors) {
      // Map backend validation errors to form errors
      Object.keys(err.errors).forEach(field => {
        errors.value[field] = err.errors[field][0]
      })

      // Show specific toast message for email already registered
      if (err.errors.email && err.errors.email[0].includes('already')) {
        toast.error(
          'This email address is already registered. Please use a different email or check if the employee already exists.'
        )
      } else {
        // Show generic validation error toast for other validation errors
        toast.error('Please check the form fields and try again.')
      }
    } else {
      const message = err?.message || 'Failed to register employee'
      toast.error('Error', message)
    }
  } finally {
    isLoading.value = false
  }
}

const handleEnterKeyPress = (event: KeyboardEvent) => {
  // Prevent default form submission behavior
  event.preventDefault()

  // Only submit if the form is valid and not currently loading
  if (isFormValid.value && !isLoading.value) {
    handleSubmit()
  }
}

// Watch for modal visibility changes to reset form
watch(
  () => props.isVisible,
  newValue => {
    if (!newValue) {
      resetForm()
    }
  }
)

// Watch for password changes to auto-update confirmation
watch(
  () => formData.value.password,
  newPassword => {
    formData.value.password_confirmation = newPassword
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Register New Employee",
    subtitle: "Create a new employee account",
    icon: _unref(UserPlus),
    size: "2xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createVNode(BaseButton, {
        text: "Cancel",
        variant: "secondary",
        disabled: isLoading.value,
        onClick: closeModal
      }, null, 8, ["disabled"]),
      _createVNode(BaseButton, {
        text: isLoading.value ? 'Registering...' : 'Register Employee',
        variant: "primary",
        disabled: isLoading.value || !isFormValid.value,
        loading: isLoading.value,
        onClick: handleSubmit
      }, null, 8, ["text", "disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          onKeydown: _withKeys(handleEnterKeyPress, ["enter"]),
          class: "space-y-6"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "email",
              class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
            }, [
              _createTextVNode(" Email Address "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
              type: "email",
              class: _normalizeClass(["modern-input w-full", {
              'border-red-500 focus:border-red-500 focus:ring-red-500/20':
                errors.value.email || isEmailInvalid.value
            }]),
              placeholder: "Enter employee email address",
              required: ""
            }, null, 2), [
              [_vModelText, formData.value.email]
            ]),
            (errors.value.email)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errors.value.email), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, [
              _createTextVNode(" Password "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                type: showPassword.value ? 'text' : 'password',
                class: _normalizeClass(["modern-input w-full pr-10", {
                'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.password
              }]),
                placeholder: "Enter password (minimum 6 characters)",
                required: "",
                minlength: "6"
              }, null, 10, _hoisted_6), [
                [_vModelDynamic, formData.value.password]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
              }, [
                (!showPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      }, null, -1),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                      }, null, -1)
                    ]))]))
              ])
            ]),
            (errors.value.password)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.value.password), 1))
              : _createCommentVNode("", true),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-500 dark:text-gray-400" }, " Password must be at least 6 characters long ", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                for: "first_name",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, [
                _createTextVNode(" First Name "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "first_name",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.first_name) = $event)),
                type: "text",
                class: _normalizeClass(["modern-input w-full", {
                'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.first_name
              }]),
                placeholder: "First name",
                required: "",
                maxlength: "100"
              }, null, 2), [
                [_vModelText, formData.value.first_name]
              ]),
              (errors.value.first_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.first_name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "middle_name",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, " Middle Name ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "middle_name",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.middle_name) = $event)),
                type: "text",
                class: _normalizeClass(["modern-input w-full", {
                'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.middle_name
              }]),
                placeholder: "Middle name (optional)",
                maxlength: "100"
              }, null, 2), [
                [_vModelText, formData.value.middle_name]
              ]),
              (errors.value.middle_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errors.value.middle_name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "last_name",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, [
                _createTextVNode(" Last Name "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "last_name",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.last_name) = $event)),
                type: "text",
                class: _normalizeClass(["modern-input w-full", {
                'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.last_name
              }]),
                placeholder: "Last name",
                required: "",
                maxlength: "100"
              }, null, 2), [
                [_vModelText, formData.value.last_name]
              ]),
              (errors.value.last_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(errors.value.last_name), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                for: "phone_number",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, " Phone Number ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "phone_number",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.phone_number) = $event)),
                type: "tel",
                class: _normalizeClass(["modern-input w-full", {
                'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.phone_number
              }]),
                placeholder: "(555) 123-4567",
                maxlength: "20"
              }, null, 2), [
                [_vModelText, formData.value.phone_number]
              ]),
              (errors.value.phone_number)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(errors.value.phone_number), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                for: "city",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, " City ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "city",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.city) = $event)),
                type: "text",
                class: _normalizeClass(["modern-input w-full", { 'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.city }]),
                placeholder: "City",
                maxlength: "100"
              }, null, 2), [
                [_vModelText, formData.value.city]
              ]),
              (errors.value.city)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(errors.value.city), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[20] || (_cache[20] = _createElementVNode("label", {
                for: "state",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, " State ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "state",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.state) = $event)),
                type: "text",
                class: _normalizeClass(["modern-input w-full", { 'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.state }]),
                placeholder: "State",
                maxlength: "100"
              }, null, 2), [
                [_vModelText, formData.value.state]
              ]),
              (errors.value.state)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(errors.value.state), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                for: "zip_code",
                class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              }, " Zip Code ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "zip_code",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.zip_code) = $event)),
                type: "text",
                class: _normalizeClass(["modern-input w-full", {
                'border-red-500 focus:border-red-500 focus:ring-red-500/20': errors.value.zip_code
              }]),
                placeholder: "12345",
                maxlength: "20"
              }, null, 2), [
                [_vModelText, formData.value.zip_code]
              ]),
              (errors.value.zip_code)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(errors.value.zip_code), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3" }, " Form Requirements ", -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (isPasswordValidLength.value)
                  ? (_openBlock(), _createBlock(_unref(CheckCircle), {
                      key: 0,
                      class: "w-5 h-5 text-green-500 mr-2 flex-shrink-0"
                    }))
                  : (formData.value.password && formData.value.password.length > 0)
                    ? (_openBlock(), _createBlock(_unref(AlertTriangle), {
                        key: 1,
                        class: "w-5 h-5 text-yellow-500 mr-2 flex-shrink-0"
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_30)),
                _createElementVNode("span", {
                  class: _normalizeClass({
                  'text-green-600 dark:text-green-400 font-medium': isPasswordValidLength.value,
                  'text-yellow-600 dark:text-yellow-400':
                    formData.value.password && formData.value.password.length > 0 && !isPasswordValidLength.value,
                  'text-gray-600 dark:text-gray-400':
                    !formData.value.password || formData.value.password.length === 0
                })
                }, " Password (minimum 6 characters) ", 2)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  (!isEmailEmpty.value && !isEmailInvalid.value)
                    ? (_openBlock(), _createBlock(_unref(CheckCircle), {
                        key: 0,
                        class: "w-4 h-4 text-green-500"
                      }))
                    : (isEmailEmpty.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33))
                      : (_openBlock(), _createBlock(_unref(AlertTriangle), {
                          key: 2,
                          class: "w-4 h-4 text-amber-500"
                        }))
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass({
                  'text-green-600 dark:text-green-400 font-medium':
                    !isEmailEmpty.value && !isEmailInvalid.value,
                  'text-amber-600 dark:text-amber-400': isEmailInvalid.value,
                  'text-gray-600 dark:text-gray-400': isEmailEmpty.value
                })
                }, _toDisplayString(isEmailEmpty.value
                    ? 'Enter a valid email address'
                    : isEmailInvalid.value
                      ? 'Please check your email format'
                      : 'Valid email address ✓'), 3)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (formData.value.password && isPasswordValidLength.value)
                    ? (_openBlock(), _createBlock(_unref(CheckCircle), {
                        key: 0,
                        class: "w-4 h-4 text-green-500"
                      }))
                    : (formData.value.password && !isPasswordValidLength.value)
                      ? (_openBlock(), _createBlock(_unref(AlertTriangle), {
                          key: 1,
                          class: "w-4 h-4 text-amber-500"
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36))
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass({
                  'text-green-600 dark:text-green-400 font-medium':
                    formData.value.password && isPasswordValidLength.value,
                  'text-amber-600 dark:text-amber-400': formData.value.password && !isPasswordValidLength.value,
                  'text-gray-600 dark:text-gray-400': !formData.value.password
                })
                }, _toDisplayString(!formData.value.password
                    ? 'Enter a password (minimum 6 characters)'
                    : !isPasswordValidLength.value
                      ? `Password needs ${6 - formData.value.password.length} more characters`
                      : 'Password meets minimum length ✓'), 3)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  (!isFirstNameEmpty.value && !isLastNameEmpty.value)
                    ? (_openBlock(), _createBlock(_unref(CheckCircle), {
                        key: 0,
                        class: "w-4 h-4 text-green-500"
                      }))
                    : (formData.value.first_name || formData.value.last_name)
                      ? (_openBlock(), _createBlock(_unref(AlertTriangle), {
                          key: 1,
                          class: "w-4 h-4 text-amber-500"
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_39))
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass({
                  'text-green-600 dark:text-green-400 font-medium':
                    !isFirstNameEmpty.value && !isLastNameEmpty.value,
                  'text-amber-600 dark:text-amber-400':
                    (formData.value.first_name || formData.value.last_name) &&
                    (isFirstNameEmpty.value || isLastNameEmpty.value),
                  'text-gray-600 dark:text-gray-400': !formData.value.first_name && !formData.value.last_name
                })
                }, _toDisplayString(isFirstNameEmpty.value && isLastNameEmpty.value
                    ? 'Enter first and last name'
                    : isFirstNameEmpty.value
                      ? 'First name is still needed'
                      : isLastNameEmpty.value
                        ? 'Last name is still needed'
                        : 'Name information complete ✓'), 3)
              ]),
              (isFormValid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_unref(CheckCircle), { class: "w-4 h-4 mr-2" }),
                      _cache[22] || (_cache[22] = _createTextVNode(" Ready to register employee ", -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h4", _hoisted_43, [
              _createVNode(_unref(Calendar), { class: "w-4 h-4 mr-2 flex-shrink-0" }),
              _cache[24] || (_cache[24] = _createTextVNode(" Module Access Months to be Assigned ", -1))
            ]),
            (hasAssignedMonths.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assignedMonthsSummary.value, (assignment) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: assignment.year,
                      class: "flex items-start text-sm"
                    }, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(assignment.year) + ": ", 1),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(assignment.months), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_47, " No months assigned — employee will not have module access until months are set. "))
          ])
        ], 32)
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "icon"]))
}
}

})